export default {
  header: 'Anlagenparameterdefinitionen',
  subheader: 'Auf dieser Seite können benutzerdefinierte Anlagenparameter verwaltet werden, die im Signal-Builder wiederverwendet werden können.',
  empty: 'Keine Benutzerdefinierten Anlagenparameter sind definiert.',
  confirmDelete: {
    header: 'Löschen bestätigen',
    message: 'Sie sind dabei, eine benutzerdefinierte Parameterdefinition zu löschen. Diese Definition wird möglicherweise von mehreren Anlagen verwendet.\n\nMöchten Sie den Parameter "{parameter}" wirklich endgültig entfernen?',
  },
};
